module.exports = __webpack_public_path__ + "img/CAT_SANOFIAVENTIS-small.93ad05ec.png";